import apiShopData from './functions/apiShopData';

const crud = {
  getShopData: apiShopData
};

export default crud;
